export const msInDay = 86400000; // 1000 * 60 * 60 * 24

export function isDayToday(day: number): boolean {
  return day === getTodaysDay();
}

export function getTodaysDay(): number {
  const date = new Date();
  const year = date.getFullYear();
  const m = date.getMonth() + 1;
  const month = String(m).length === 1 ? `0${m}` : m;
  const d = date.getDate();
  const day = String(d).length === 1 ? `0${d}` : d;

  const currentDate = new Date(`${year}-${month}-${day}`);
  return currentDate.getTime() / msInDay;
}
